import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../../Constant";
import { Line, Circle } from "rc-progress";
import Swal from "sweetalert2";

export default class LandingPageCourseList extends Component {
  state = {
    courses: [],
  };
  componentDidMount() {
    //API will be called here
    this.getCourses();
  }
  getCourses = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    // myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", window.location.hostname.split('.')[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getLandingPageSiteAPI() + "/course/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        // var course_data = [];
        // for (let i = 0; i < data.length; i++) {
        //   var obj = {};
        //   obj.name = data[i].name;
        //   obj.image = data[i].image;
        //   obj.id = data[i].id;
        //   if (
        //     data[i].enroll !== null &&
        //     data[i].enroll !== [] &&
        //     data[i].enroll.length > 0
        //   ) {
        //     for (var j = 0; j < data[i].enroll.length; j++) {
        //       if (data[i].enroll[j].id === localStorage.getItem("lms_uid")) {
        //         obj.isEnrolled = true;
        //       } else {
        //         obj.isEnrolled = false;
        //       }
        //     }
        //   }
        //   course_data.push(obj);
        // }
        // console.log("courses : ", course_data);
        // return false;
        this.setState({ courses: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  onSelectedOptions = () => { };
  onChangeCourseListner = () => {
    // filter data from here
  };

  onEnrollUser = (event) => {
    if (localStorage.getItem("lms_uid") !== undefined && localStorage.getItem("lms_uid") !== null && localStorage.getItem("lms_uid") !== "") {
      console.log(event.target.id);
      var courseId = event.target.id;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

      var urlencoded = new URLSearchParams();
      urlencoded.append("userId", localStorage.getItem("lms_uid"));
      urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
      urlencoded.append("courseId", courseId);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      fetch(Constant.getAPI() + "/course/enroll", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // document.location.reload();
          if (result.status === true) {
            this.getCourses();
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      Swal.fire("Please Login First to Enroll the Course..!");
    }
  };
  onRemoveEnrollUser = (event) => {
    console.log(event.target.id);
    var courseId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/unEnroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getCourses();
        }
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    console.log("DATA", this.state.courses);
    return (
      <div>
        {this.state.courses !== undefined && this.state.courses !== null && this.state.courses !== [] && this.state.courses.length > 0
          ?
          <div className="py-3">
            <div className="container create-course border shadow-sm p-0 bg-white">
              <div className="header text-primary">
                <h4 className="p-2">Course We Provide</h4>
              </div>
              <div className="row m-0">
                <div className="col-md-12 border-right p-0">
                  <div className="row p-2 m-0">
                    {this.state.courses.map((course) => {
                      return (
                        <div className="col-md-2 my-3" id={course.id}>
                          <div
                            className="card card-selector shadow-sm mt-1 h-100"
                            onClick={this.cardSelect}
                          >
                            {course.isPaid === true
                              ?
                              <span class="ribbon3">Paid</span>
                              :
                              null}
                            {course.isEnrolled === true ? (
                              <Link
                                to={`/learner/course/${course.id}`}
                                className="link-unstyled"
                              >
                                <div>
                                  <img
                                    class="card-img-top course-image"
                                    src={
                                      course.image !== ""
                                        ? course.image
                                        : "./images/homepage/placeholder-img.jpg"
                                    }
                                    alt="course alt"
                                    onError={e => {
                                      e.target.src = "./images/homepage/placeholder-img.jpg"
                                    }}
                                  />
                                  <div class="card-body text-center p-2">
                                    <h6
                                      className="mb-0"
                                      style={{ minHeight: "40px" }}
                                    >
                                      {course.name}
                                    </h6>
                                  </div>
                                </div>
                              </Link>
                            ) : (
                                <div
                                  onClick={() => {
                                    Swal.fire(
                                      "Error",
                                      "Please Enroll the Course to go furthur",
                                      "warning"
                                    );
                                  }}
                                >
                                  <img
                                    class="card-img-top course-image"
                                    src={
                                      course.image !== ""
                                        ? course.image
                                        : "./images/homepage/placeholder-img.jpg"
                                    }
                                    alt="course alt"
                                  />
                                  <div class="card-body text-center p-2">
                                    <h6
                                      className="mb-0"
                                      style={{ minHeight: "40px" }}
                                    >
                                      {course.name}
                                    </h6>
                                  </div>
                                </div>
                              )}
                            {/* {course.isEnrolled === true ?
                          <Link
                            to={`/certificates/${course.id}`}
                            className="btn btn-warning shadow-sm mx-1"
                          > DownLoad Certificate
                          </Link>
                          :
                          null} */}
                            {course.isEnrolled === true ? (
                              <button
                                class="btn btn-danger shadow-sm mx-1"
                                id={course.id}
                                onClick={this.onRemoveEnrollUser}
                              >
                                Remove
                              </button>
                            ) : (
                                <button
                                  class="btn shadow-sm mx-1 btn-primary"
                                  id={course.id}
                                  onClick={this.onEnrollUser}
                                >
                                  Enroll
                                </button>
                              )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
      </div>
    );
  }
}
